const Logo = ({ imgClass = "h-12", className = "" }) => (
  <img
    src="/logo.png"
    alt="HR99 Global Services"
    className={`${imgClass} w-auto object-contain [image-rendering:-webkit-optimize-contrast] ${className}`}
  />
);

export default Logo;
